





































import Vue from 'vue'
import Component from 'vue-class-component'
import axios from 'axios'

import ModuleList from '../../modules/components/List.vue'
import { IModule } from '../../modules/types'
import { Prop, Watch } from 'vue-property-decorator'

import { ICourse } from '../types'

@Component
export default class CreateDialog extends Vue {
  @Prop({ default: false })
  open!: boolean

  @Prop()
  initialData!: ICourse

  data: ICourse = {}

  get mode() {
    return this.data.id ? 'update' : 'create'
  }

  mounted() {
    if (this.initialData) {
      this.data = { ...this.initialData }
    }
  }

  @Watch('initialData')
  initialDataChanged(value: ICourse, oldValue: ICourse) {
    this.data = { ...value }
  }

  submit() {
    this.$emit('save', { ...this.data })
    this.data = this.initialData || {}
  }

  cancel() {
    this.data = {}
    this.$emit('cancel')
  }
}
